// slick crousel
$(function() {
  $('.cssskin--js-multiple-item-carousel .g-column').slick({
    infinite: true,
    dots:false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
      breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      }
    }
    ]
  });
  
  // read more
  if ($('.cssskin--js-readmore-p')[0]) {
  	const $readmore = $('.cssskin--js-readmore-p .read-more');
  	$('.cssskin--js-readmore-p .c-body').hide();
  	$readmore.on("click", function(e) {
      e.preventDefault();
      $(this).prev().slideToggle();
      if ($('a', this).text() == "続きを読む" ) {
      	$('a', this).text( "閉じる" );
      } else {
      	$('a', this).text( "続きを読む" );
      }
    });
  }
  
  // search bar
  /* 2023.02.17 mikihouse ヘッダー構成変更により非表示
   $('.js-search-input-toggle').on("click",(function(e){
      e.preventDefault();
      $('#SearchDrawer').slideToggle();
  }));
  $('.js-drawer-close').on("click",(function(e){
      e.preventDefault();
      $('#SearchDrawer').slideToggle();
  }))

  
  
  // megamenu click event
  const events = $._data($('.megamenu-list > li').get(0), 'events');
  if (events && events.mouseover && events.mouseout) {
  const mouseoverHandler = events.mouseover[0].handler;
  const mouseoutHandler = events.mouseout[0].handler;
  $('.megamenu-list > li')
  .off('mouseenter mouseleave')
  .on('click', function() {
    if ($(this).find('.b-megamenu_navigation').hasClass('-active')) {
      mouseoutHandler.apply(this);
    } else {
      mouseoverHandler.apply(this);
    }
  });
  }
 */
  
});


//20220225 SPゴーストヘッダー
/* 2023.02.17 mikihouse ヘッダー構成変更により非表示
var w_width = 0;
var w_hight = 0;
$(window).on('load resize', function(){
    w_width = $(window).width();
    w_hight = $(window).outerHeight();
    //console.log (w_width);
    $(".cssskin-_block_header_ghost .g-column").css({
      "display":"none"
    });
});
$(window).on("scroll", function() {
  if ($(this).scrollTop() > 54) {
    $(".cssskin-_block_header_ghost .g-column").fadeIn("slow");
    $("#SearchDrawer").fadeOut("slow");
  } else {
    $(".cssskin-_block_header_ghost .g-column").fadeOut("slow");
  };
});
*/











